import { Outlet } from 'react-router'
import { NavLink } from 'react-router-dom'

import { ROUTER_NAMES } from 'router/routerNames'

import styles from './ApplicationsLayout.module.scss'

function activeClassName({ isActive }: { isActive: boolean }) {
  return `${styles.nav_item} ${isActive ? styles.active : ''}`
}

export const ApplicationsLayout = () => {
  return (
    <>
      <div className="container">
        <div className={styles.nav_list}>
          <NavLink
            end
            className={activeClassName}
            to={ROUTER_NAMES.APPLICATIONS}
          >
            Карты
          </NavLink>
          <NavLink className={activeClassName} to={ROUTER_NAMES.NON_RESIDENT}>
            Не резиденты
          </NavLink>
          <NavLink className={activeClassName} to={ROUTER_NAMES.INSTANT_CARD}>
            Картоматы
          </NavLink>
          <NavLink className={activeClassName} to={ROUTER_NAMES.MBONUS}>
            МБонус
          </NavLink>
          <NavLink className={activeClassName} to={ROUTER_NAMES.MKASSA}>
            МКасса
          </NavLink>
          <NavLink className={activeClassName} to={ROUTER_NAMES.MPOST}>
            Смартпос
          </NavLink>
          <NavLink className={activeClassName} to={ROUTER_NAMES.MBUSINESS}>
            МБизнес
          </NavLink>
          <NavLink className={activeClassName} to={ROUTER_NAMES.OPEN_MBUSINESS}>
            МБизнес ИП (новый)
          </NavLink>
          <NavLink className={activeClassName} to={ROUTER_NAMES.MQR}>
            MQR
          </NavLink>
          <NavLink className={activeClassName} to={ROUTER_NAMES.MPLUS}>
            М+/(Мурабаха)
          </NavLink>
          <NavLink className={activeClassName} to={ROUTER_NAMES.REVIVAL}>
            Реанимация
          </NavLink>
          <NavLink className={activeClassName} to={ROUTER_NAMES.ACQUIRED_CLIENTS}>
            Привлеченные
          </NavLink>
          <NavLink
            className={activeClassName}
            to={ROUTER_NAMES.MANUAL_REPORTS}
          >
            Ручные отчёты
          </NavLink>
          <NavLink
            className={activeClassName}
            to={ROUTER_NAMES.APPLICATION_AUTO_REPORTS}
          >
            Автовыгрузки
          </NavLink>
        </div>
      </div>

      <Outlet />
    </>
  )
}
